import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-57" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-58" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-forest-600 text-white" data-id="element-59" data-mp="2223lxxjryni5">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-60" data-mp="1x54p378q82g9" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-61" data-mp="19faeyxfskrzp">
          Garantía de 7 días
        </h2>

        <div className="mt-9 rounded-2xl bg-white px-6 py-9 shadow-soft ring-1 ring-gray-200 md:px-10" data-id="element-62" data-mp="1j52du3uxc79z">
          <p className="text-lg leading-relaxed text-gray-500 md:text-xl" data-id="element-63" data-mp="1edkaxa9cbwmd">
            Probá sin riesgo. Si en 7 días no te convence, devolvemos tu dinero. Sin preguntas.{' '}
            <span className="font-display font-extrabold text-ink" data-id="element-64" data-mp="lp6ev01tbadg">Sabemos que funciona.</span>
          </p>
          <p className="mt-6 font-display text-lg font-extrabold leading-snug tracking-tight text-ink md:text-xl" data-id="element-65" data-mp="ozrmu7gdw7y8">
            Pero queremos que vos lo compruebes.
          </p>
        </div>
      </div>
    </section>;
}